import React from 'react';
import { Box, Menu, MenuItem, Typography } from '@mui/material';
import { DotsHorizontal } from 'components/SVG';
import DownloadIcon from 'components/SVG/DownloadIcon';
import { IconButtonWrapper } from 'sharedComponents/UI';
import DeleteMemoryQA from 'components/SVG/DeleteMemoryQA';
import VisibilityMemoryQA from 'components/SVG/VisibilityMemoryQA';

type MemoryOptionsModalProps = {
  row: {
    id: string;
    azureBLOBURL: string;
  };
  handleFileDownload: (url: string) => void;
  handleFileViewClick: (url: string) => void;
  handleDeleteFile: (id: string) => void;
};

const MemoryOptionsModal: React.FC<MemoryOptionsModalProps> = ({
  row,
  handleFileDownload,
  handleFileViewClick,
  handleDeleteFile,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(anchorEl);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <IconButtonWrapper onClick={handleMenuOpen}>
        <DotsHorizontal />
      </IconButtonWrapper>
      <Menu anchorEl={anchorEl} open={isMenuOpen} onClose={handleMenuClose}>
        <MenuItem
          onClick={() => {
            handleFileDownload(row.azureBLOBURL);
            handleMenuClose();
          }}
        >
          <Box display='flex' alignItems='center' gap={1}>
            <DownloadIcon width='16px' height='16px' color='#404040' />
            <Typography
              variant='body2'
              marginTop={0.5}
              fontSize='18px'
              fontFamily='Mont-regular'
            >
              Download
            </Typography>
          </Box>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleFileViewClick(row.azureBLOBURL);
            handleMenuClose();
          }}
        >
          <Box display='flex' alignItems='center' gap={1}>
            <VisibilityMemoryQA width='16px' height='16px' />

            <Typography
              variant='body2'
              marginTop={0.5}
              fontSize='18px'
              fontFamily='Mont-regular'
            >
              View
            </Typography>
          </Box>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleDeleteFile(row.id);
            handleMenuClose();
          }}
        >
          <Box display='flex' alignItems='center' gap={1}>
            <DeleteMemoryQA width='16px' height='16px' />
            <Typography
              variant='body2'
              marginTop={0.5}
              fontSize='18px'
              fontFamily='Mont-regular'
            >
              Delete
            </Typography>
          </Box>
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default MemoryOptionsModal;
